import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import { TableCell, TableRow, Box } from '@mui/material'

import { colors } from '@/theme/index.theme'

import { getDateForTable, getDateTimeFromIsoUTC } from '@/utils'
import { TimeZoneUTCType } from '@/enums'
import { dateTimeTableFormat } from '@/constants/date'

import { TransactionWalletsLibraryColumnProps } from '@/state/transactions/models'

type Props = {
  row: TransactionWalletsLibraryColumnProps
}

export const TransactionsTableStandardRow = ({ row }: Props) => {
  const { t } = useTranslation()

  return (
    <TableRow hover>
      <TableCell>
        {row.date !== '-'
          ? getDateForTable(
              `${format(
                getDateTimeFromIsoUTC(
                  row.date,
                  TimeZoneUTCType['GMT-07 Pacific Time'],
                ),
                dateTimeTableFormat,
              )} PT`,
            )
          : row.date}
      </TableCell>
      <TableCell>{row.id}</TableCell>
      <TableCell align="center">
        <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: row.transactionType === 1 ? colors.green : colors.blue,
            }}
          />
          {row.transactionType === 1
            ? t('transaction.transactionType.WIN')
            : t('transaction.transactionType.BET')}
        </Box>
      </TableCell>
      <TableCell>{row.gameProviderName}</TableCell>
      <TableCell>{row.gameCategoryName}</TableCell>
      <TableCell>{row.gameName}</TableCell>
      <TableCell>{row.amountText}</TableCell>
      <TableCell>{row.walletBalanceAfterText}</TableCell>
      <TableCell>{row.rolloverContText}</TableCell>
      <TableCell>{row.currentRolloverText}</TableCell>
    </TableRow>
  )
}
